var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showModal)?_c('div',{class:[
    _vm.modalClass,
  ],attrs:{"id":"sac-modal-overlay"}},[(_vm.close)?_c('div',{staticClass:"close-background",on:{"click":_vm.hideModal,"keydown":_vm.hideModal}}):_vm._e(),_c('div',{class:[
      'modal-card',
      _vm.dark ? 'dark' : '',
      _vm.show ? 'fade-in' : 'fade-out',
      _vm.cardClass,
    ]},[_vm._t("content")],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }